module.exports = __webpack_public_path__ + "img/Survival-Gear-Packed.5204592b.jpg";